import { getAmpConfig } from 'shared/config/amp-config';

export const getRetailUrl = () => `${getAmpConfig().gateway}/retail-composite`;

export const userAssetsQueryParams =
  'includeMetadata=true&includeArchived=false&limit=5000';

export const userProgramQueryParams =
  'expandAssets=true&includeProgramMetadata=true&includeArchived=true&limit=5000';
